import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxFileUploaderModule } from 'devextreme-angular';

@Component({
  selector: 'dk-form-photo',
  standalone: true,
  imports: [CommonModule,DxFileUploaderModule],
  templateUrl: './form-photo.component.html',
  styleUrls: ['./form-photo.component.scss'],
})
export class FormPhotoComponent implements OnInit {

  @Input() link: string = ''

  @Input() editable = true;

  @Input() size = 80;

  imageUrl: string;

  hostRef = this.elRef.nativeElement;

  constructor(private elRef:ElementRef) {}

  ngOnInit() {
    this.imageUrl = this.link
  }
}
